import { USER_CONTEXT, ROLES } from "../../../../constants";

/**
 * Returns tab config for Admin User Profile per CC-13942.
 * - Facilities: not visible for Superadmin profiles
 * - Learner Groups: only when viewing own profile (My Profile)
 * - Details: only for attorney profiles
 */
const useTabDetailsHook = ({ profileId, allTabs, global, isDisableV1MessagingEnabled, roleType, createStaffV2Enabled }) => {
    const isViewingOwnProfile = profileId === USER_CONTEXT.personId;
    const isSuperAdmin = global.isSuperAdmin;
    const isFacilityAdmin = global.isFacilityAdmin;

    const useNewTabs = Boolean(createStaffV2Enabled);
    if (useNewTabs) {
        const tabs = [];
        if (isSuperAdmin) {
            if (isViewingOwnProfile) {
                tabs.push({ id: allTabs.Learner_Group, label: "Learner Groups" });
            }
            return tabs;
        }
        tabs.push({ id: allTabs.Roles, label: "Facilities", icon: "flag" });
        if (isViewingOwnProfile) {
            tabs.push({ id: allTabs.Learner_Group, label: "Learner Groups", icon: "group" });
        }
        if (roleType === ROLES.ATTORNEY) {
            tabs.push({ id: allTabs.Details, label: "Details", icon: null });
        }
        return tabs;
    }

    const TABS = [
        { id: allTabs.Details, label: "Details" },
        { id: allTabs.Relationship, label: "Relationship" },
        { id: allTabs.Roles, label: "Roles" }
    ];

    if (isViewingOwnProfile) {
        TABS.push({ id: allTabs.Learner_Group, label: "Learner Groups" });
    }

    if (isSuperAdmin || isFacilityAdmin) {
        TABS.splice(1, 0, { id: allTabs.Communication, label: "Communication" });
    }

    if (isDisableV1MessagingEnabled) {
        return TABS.filter(tab => tab.id !== allTabs.Relationship && tab.id !== allTabs.Communication);
    }

    return TABS;
};

export default useTabDetailsHook;
